import {CoreMenu} from '@core/types';

export const menu: CoreMenu[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'MENU.DASHBOARD',
        type: 'item',
        icon: 'fas fa-sign',
        url: 'dashboard',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'HEAD_COUNSELLOR', 'COUNSELLOR', 'UNIVERSITY',]
    },
    {
        id: 'program',
        title: 'Leads',
        translate: 'MENU.PROGRAM',
        type: 'item',
        icon: 'fas fa-sliders-h',
        url: 'program',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR']
    },
    {
        id: 'counseling',
        title: 'Counseling',
        translate: 'MENU.COUNSELING',
        type: 'item',
        icon: 'fas fa-headset',
        url: 'counseling',
        availableTo: ['SUPER_ADMIN', 'ADMIN', 'COUNSELLOR']
    }
];
